import React, { useState } from 'react'
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Stepper, Step } from "react-form-stepper";

function SelllMyCarPopup({ data, onClose, currentStep, handleNext, handleBack, inputs, handleInputChange, handleOptionChange, handleCommentChange, isStepValid }) {


    return (
        <div
            className={`modal show modal-xl`}
            id="sellModal"
            style={{ display: "block", zIndex: 500 }}
            role="dialog">
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-header d-flex justify-content-between">
                        <h3 className="modal-title">Sell My Car</h3>
                        <button
                            onClick={onClose}
                            type="button"
                            className="close closeModal bg-transparent border-0"
                            data-bs-dismiss="modal">
                            <FontAwesomeIcon
                                icon={faXmark}
                                size="lg"
                            />
                        </button>
                    </div>
                    <div className="modal-body modal-style-body">
                        <Stepper activeStep={currentStep}>
                            <Step label="Mileage" />
                            <Step label="Modifications" />
                            <Step label="Condition" />
                            <Step label="Summary" />
                            <Step label="Mechanical Issue" />
                            <Step label="Cosmetic Issue" />
                            <Step label="Sell or Trade" />
                            <Step label="Your Details" />
                        </Stepper>

                        <div className="step-content">
                            {currentStep === 0 && (
                                <div>
                                    <label>Mileage (must be ≤ 20000):</label>
                                    <input
                                        type="number"
                                        value={inputs.mileage}
                                        onChange={(e) => handleInputChange('mileage', e.target.value)}
                                        placeholder="Enter mileage"
                                    />
                                </div>
                            )}
                            {currentStep === 1 && (
                                <div>
                                    <label>Do you have a service history?</label>
                                    <div>
                                        <input
                                            type="radio"
                                            name="yesNo"
                                            value="yes"
                                            checked={inputs.yesNo === 'yes'}
                                            onChange={(e) => handleInputChange('yesNo', e.target.value)}
                                        /> Yes
                                        <input
                                            type="radio"
                                            name="yesNo"
                                            value="no"
                                            checked={inputs.yesNo === 'no'}
                                            onChange={(e) => handleInputChange('yesNo', e.target.value)}
                                        /> No
                                    </div>
                                </div>
                            )}
                            {currentStep === 2 && (
                                <div>
                                    <label>Condition:</label>
                                    <div>
                                        <input
                                            type="radio"
                                            name="condition"
                                            value="clean"
                                            checked={inputs.condition === 'clean'}
                                            onChange={(e) => handleInputChange('condition', e.target.value)}
                                        /> Clean
                                        <input
                                            type="radio"
                                            name="condition"
                                            value="average"
                                            checked={inputs.condition === 'average'}
                                            onChange={(e) => handleInputChange('condition', e.target.value)}
                                        /> Average
                                        <input
                                            type="radio"
                                            name="condition"
                                            value="rough"
                                            checked={inputs.condition === 'rough'}
                                            onChange={(e) => handleInputChange('condition', e.target.value)}
                                        /> Rough
                                        <input
                                            type="radio"
                                            name="condition"
                                            value="damaged"
                                            checked={inputs.condition === 'damaged'}
                                            onChange={(e) => handleInputChange('condition', e.target.value)}
                                        /> Damaged
                                        <input
                                            type="radio"
                                            name="condition"
                                            value="notSure"
                                            checked={inputs.condition === 'notSure'}
                                            onChange={(e) => handleInputChange('condition', e.target.value)}
                                        /> Not Sure
                                    </div>
                                </div>
                            )}
                            {currentStep === 3 && (
                                <div>
                                    <h4>Summary</h4>
                                    <p>Mileage: {inputs.mileage}</p>
                                    <p>Service History: {inputs.yesNo}</p>
                                    <p>Condition: {inputs.condition}</p>
                                </div>
                            )}
                            {currentStep === 4 && (
                                <div>
                                    <label>Select options for mechanical assessment:</label>
                                    <div>
                                        <input
                                            type="checkbox"
                                            name="none"
                                            checked={inputs.step4Options.none}
                                            onChange={() => handleOptionChange(4, 'none')}
                                        /> None
                                    </div>
                                    {['engine', 'suspension', 'fluidLeaks', 'dashWarningLights', 'tiresBrakesBattery', 'acHeater', 'powerFeatures', 'others'].map(option => (
                                        <div key={option}>
                                            <input
                                                type="checkbox"
                                                name={option}
                                                checked={inputs.step4Options[option]}
                                                onChange={() => handleOptionChange(4, option)}
                                            /> {option.replace(/([A-Z])/g, ' $1')}
                                            {inputs.step4Options[option] && (
                                                <div>
                                                    <label>Comment:</label>
                                                    <textarea
                                                        value={inputs.step4Comments[option]}
                                                        className='form-control'
                                                        onChange={(e) => handleCommentChange(4, option, e.target.value)}
                                                        placeholder={`Enter your comment for ${option.replace(/([A-Z])/g, ' $1')}`}
                                                    ></textarea>
                                                </div>
                                            )}
                                        </div>
                                    ))}
                                </div>
                            )}
                            {currentStep === 5 && (
                                <div>
                                    <label>Select options for cosmetic assessment:</label>
                                    <div>
                                        <input
                                            type="checkbox"
                                            name="none"
                                            checked={inputs.step5Options.none}
                                            onChange={() => handleOptionChange(5, 'none')}
                                        /> None
                                    </div>
                                    {['engine', 'suspension', 'fluidLeaks', 'dashWarningLights', 'tiresBrakesBattery', 'acHeater', 'powerFeatures', 'others'].map(option => (
                                        <div key={option}>
                                            <input
                                                type="checkbox"
                                                name={option}
                                                checked={inputs.step5Options[option]}
                                                onChange={() => handleOptionChange(5, option)}
                                            /> {option.replace(/([A-Z])/g, ' $1')}
                                            {inputs.step5Options[option] && (
                                                <div>
                                                    <label>Comment:</label>
                                                    <textarea
                                                        value={inputs.step5Comments[option]}
                                                        onChange={(e) => handleCommentChange(5, option, e.target.value)}
                                                        className='form-control'
                                                        placeholder={`Enter your comment for ${option.replace(/([A-Z])/g, ' $1')}`}
                                                    ></textarea>
                                                </div>
                                            )}
                                        </div>
                                    ))}
                                </div>
                            )}
                            {currentStep === 6 && (
                                <div>
                                    <label>What do you want to do?</label>
                                    <div>
                                        <input
                                            type="radio"
                                            name="sellTradeIn"
                                            value="sell"
                                            checked={inputs.sellTradeIn === 'sell'}
                                            onChange={(e) => handleInputChange('sellTradeIn', e.target.value)}
                                        /> I want to sell
                                        <input
                                            type="radio"
                                            name="sellTradeIn"
                                            value="tradeIn"
                                            checked={inputs.sellTradeIn === 'tradeIn'}
                                            onChange={(e) => handleInputChange('sellTradeIn', e.target.value)}
                                        /> I want to trade in
                                        <input
                                            type="radio"
                                            name="sellTradeIn"
                                            value="notSure"
                                            checked={inputs.sellTradeIn === 'notSure'}
                                            onChange={(e) => handleInputChange('sellTradeIn', e.target.value)}
                                        /> Not sure
                                    </div>
                                </div>
                            )}

                            {currentStep === 7 && (
                                <div>
                                    <label>Full Name:</label>
                                    <input
                                        type="text"
                                        value={inputs.fullName}
                                        className='form-control'
                                        onChange={(e) => handleInputChange('fullName', e.target.value)}
                                        placeholder="Enter your full name"
                                    />

                                    <label>Email:</label>
                                    <input
                                        type="email"
                                        value={inputs.email}
                                        className='form-control'
                                        onChange={(e) => handleInputChange('email', e.target.value)}
                                        placeholder="Enter your email"
                                    />

                                    <label>Phone Number:</label>
                                    <input
                                        type="tel"
                                        value={inputs.phoneNumber}
                                        className='form-control'
                                        onChange={(e) => handleInputChange('phoneNumber', e.target.value)}
                                        placeholder="Enter your phone number"
                                    />
                                </div>
                            )}

                        </div>

                        <div className="d-flex justify-content-between mt-3">
                            <button
                                className="btn btn-secondary"
                                onClick={handleBack}
                                disabled={currentStep === 0}>
                                Back
                            </button>
                            <button
                                className="btn btn-primary"
                                onClick={handleNext}
                                disabled={!isStepValid()}>
                                Next
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default SelllMyCarPopup